<template>
    <v-row dense>
      <v-col cols="12" sm="6">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="NATUREZA"
          label="Natureza"
          required
          class="required rounded-tag-small"
          v-model="formData.natureza"/>
      </v-col>
    </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
